<script lang="ts">
import { defineComponent } from 'vue'
import PrimaryButton from './ui/buttons/PrimaryButton.vue';
import SecondaryButton from './ui/buttons/SecondaryButton.vue';

export default defineComponent({
    name: 'TheWelcome',

    components: { PrimaryButton, SecondaryButton }
})
</script>

<template>
    <div class="min-h-[70vh] flex items-center justify-center px-4">
        <div class="relative w-full rounded-3xl p-10 overflow-hidden">

            <div class="relative z-10 text-center flex flex-col items-center gap-4">

                <img src="@/assets/illustration.png" alt="illustration" class="w-3/4 md:w-1/2">

                <h1 class="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight">
                    Welcome to <span class="text-indigo-600">PayLog</span>
                </h1>

                <p class="text-gray-600 max-w-md">
                    Your all-in-one dashboard to manage payments & users.
                </p>

                <div class="flex flex-col md:flex-row gap-3 mt-4">
                    <RouterLink to="/payments">
                        <PrimaryButton :btn-txt="'View Payments'" />
                    </RouterLink>
                    <RouterLink to="/users">
                        <SecondaryButton :btn-txt="'View Users'"/>
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>
</template>
